import { createApp } from 'vue';
import i18n from './i18n';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';
import './styles/theme.css';
import App from './App.vue';
import router from './router';
import store from './store';
import { io } from 'socket.io-client';
import { SOCKET_URL } from './api';

const socket = io(SOCKET_URL, { autoConnect: false });

function syncSocketAuth() {
  const token = localStorage.getItem('token');
  socket.auth = token ? { token: `Bearer ${token}` } : {};
}

function handleUnauthorized() {
  store.commit('auth/clearUser');
  syncSocketAuth();
  if (socket.connected) socket.disconnect();
  if (router.currentRoute.value?.path !== '/login') {
    router.push('/login').catch(() => {});
  }
}

socket.on('onlineUsers', (users) => {
  store.commit('auth/setOnlineUsers', users);
});

socket.on('connect_error', (error) => {
  if (localStorage.getItem('token') && /auth/i.test(error?.message || '')) {
    handleUnauthorized();
  }
});

window.addEventListener('auth:unauthorized', handleUnauthorized);

socket.on('drone:telemetry', ({ drone, telemetry }) => {
  store.commit('drones/upsertDrone', drone);
  store.commit('drones/appendTelemetry', { droneId: drone?._id || telemetry?.drone_id, telemetry });
});

socket.on('drone:status', ({ drone_id, status, stream_status, last_seen_at }) => {
  const current = store.state.drones.drones.find((item) => String(item._id) === String(drone_id));
  if (current) store.commit('drones/upsertDrone', { ...current, status, stream_status, last_seen_at });
});

async function bootstrap() {
  syncSocketAuth();
  if (localStorage.getItem('token')) {
    const user = await store.dispatch('auth/loadMe');
    syncSocketAuth();
    if (user) socket.connect();
  } else {
    store.commit('auth/setInitialized', true);
  }

  const app = createApp(App);
  app.config.globalProperties.$socket = socket;
  app.config.globalProperties.$syncSocketAuth = syncSocketAuth;
  app.use(store).use(router).use(i18n).mount('#app');
}

bootstrap();
